import { useEffect } from "react";
import HomeHero from "../../components/home/hero/HomeHero.tsx";
import HomeTopics from "../../components/home/topics/HomeTopics.tsx";
import CallToAction from "../../components/generic/call-to-action/CallToAction.tsx";

function HomePage() {
    return (
        <>
            <HomeHero />
            <HomeTopics />
            <CallToAction heading="Your next skill is one click away."
                          text="Create a free account, track your progress, and earn certificates." />
        </>
    );
}

export default HomePage;